<div class="tpl3pl-page-container tpl3pl-list-page inventory-page">
	<h6 class="text-muted text-uppercase small font-weight-bold mb-2 section-inv-heading">3PL inventory (PGS)</h6>
	<p class="text-muted small mb-3">
		Cached quantities from the last PGS inventory pull (<strong>Manual sync (raw)</strong> below). ERP locstock updates apply when the sync completes.
		In that dialog, <strong>New SKUs only</strong> applies the feed but only for SKU+warehouse rows not yet in the cache (after a full sync, use this when PGS adds items).
		<a routerLink="../inbound">Inbound</a>
		if the 3PL has no stock yet.
	</p>

	<div class="top-bar">
		<div class="top-bar-left">
			<mat-form-field appearance="outline" class="field-warehouse">
				<mat-label matTooltip="Mapped ERP location (loccode). Leave blank for all.">Warehouse</mat-label>
				<input matInput [(ngModel)]="selectedWarehouse" placeholder="All" (blur)="onWarehouseBlur()">
			</mat-form-field>
			<mat-form-field appearance="outline" class="field-search">
				<mat-label>Search SKU, warehouse, status</mat-label>
				<input matInput [ngModel]="itemListSearch" (ngModelChange)="onInventorySearchInput($event)">
				<mat-icon matSuffix>search</mat-icon>
			</mat-form-field>
			<mat-form-field appearance="outline" class="field-status">
				<mat-label>Sync status</mat-label>
				<mat-select [(ngModel)]="inventoryStatusFilter" (selectionChange)="onStatusFilterChange()">
					<mat-option value="">All</mat-option>
					<mat-option value="synced">Synced</mat-option>
					<mat-option value="pending">Pending</mat-option>
					<mat-option value="error">Error</mat-option>
				</mat-select>
			</mat-form-field>
			<span class="count-chip" *ngIf="!loading && inventoryStatus?.success">
				Scope {{ (inventoryStatus.catalog_items ?? 0) | number }} SKUs · Cached {{ (inventoryStatus.total_items ?? 0) | number }} rows
			</span>
			<span class="count-chip text-warning" *ngIf="!loading && inventoryStatus?.success && (inventoryStatus.total_items ?? 0) === 0 && (inventoryStatus.catalog_items ?? 0) > 0">
				Cache empty — run Manual sync (raw)
			</span>
		</div>
		<div class="top-bar-right">
			<button
				mat-stroked-button
				(click)="exportXls()"
				[disabled]="exportingXls || loading || inventoryListTotal === 0"
				matTooltip="Export filtered list to Excel (server print/xls)">
				<mat-icon *ngIf="!exportingXls">grid_on</mat-icon>
				<mat-spinner *ngIf="exportingXls" diameter="18" class="btn-spinner"></mat-spinner>
				Export XLSX
			</button>
			<button mat-icon-button (click)="onRefresh()" [disabled]="loading || inventoryListLoading" matTooltip="Refresh status and list">
				<mat-icon>refresh</mat-icon>
			</button>
		</div>
	</div>

	<div class="action-bar">
		<div class="action-bar-left">
			<button mat-stroked-button (click)="openManualSyncRaw()" [disabled]="manualSyncRawLoading">
				<mat-spinner *ngIf="manualSyncRawLoading" diameter="18" class="btn-spinner"></mat-spinner>
				<mat-icon *ngIf="!manualSyncRawLoading">code</mat-icon>
				Manual sync (raw)
			</button>
		</div>
		<div class="action-bar-right">
			<button mat-stroked-button color="warn" (click)="clearSyncedInventory()" [disabled]="clearing">
				<mat-spinner *ngIf="clearing" diameter="18" class="btn-spinner"></mat-spinner>
				<mat-icon *ngIf="!clearing">delete_sweep</mat-icon>
				Clear synced inventory
			</button>
		</div>
	</div>

	<div *ngIf="loading" class="text-center py-4">
		<mat-spinner diameter="32"></mat-spinner>
		<p class="text-muted small mt-2">Loading status…</p>
	</div>

	<div *ngIf="inventoryStatus && !loading" class="inventory-stat-cards mb-3">
		<div class="row">
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card" matTooltip="Rows from last pull into tpl3pl_inventory">
					<div class="stat-label">Cached</div>
					<div class="stat-value">{{ (inventoryStatus.total_items || 0) | number }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card" matTooltip="SUM(quantity_on_hand) from synced 3PL cache rows">
					<div class="stat-label">Total QOH</div>
					<div class="stat-value">{{ (inventoryStatus.total_qoh || 0) | number:'1.0-2' }}</div>
					<div class="stat-sub">3PL available: {{ (inventoryStatus.total_available || 0) | number:'1.0-2' }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card" matTooltip="SUM(locstock.quantity) for the same SKU+warehouse pairs">
					<div class="stat-label">Internal QOH</div>
					<div class="stat-value">{{ (inventoryStatus.total_internal_qoh || 0) | number:'1.0-2' }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card" matTooltip="Open sales-order demand (qty - invoiced) scoped to listed SKU+warehouse rows">
					<div class="stat-label">On demand</div>
					<div class="stat-value">{{ (inventoryStatus.total_on_demand || 0) | number:'1.0-2' }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card stat-synced" matTooltip="sync_status = synced">
					<div class="stat-label">Synced</div>
					<div class="stat-value">{{ (inventoryStatus.synced_items || 0) | number }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card stat-pending" matTooltip="sync_status = pending">
					<div class="stat-label">Pending</div>
					<div class="stat-value">{{ (inventoryStatus.pending_items || 0) | number }}</div>
				</div>
			</div>
			<div class="col-6 col-md-4 col-lg">
				<div class="stat-card stat-errors" matTooltip="sync_status = error">
					<div class="stat-label">Errors</div>
					<div class="stat-value">{{ (inventoryStatus.error_items || 0) | number }}</div>
				</div>
			</div>
			<div class="col-12 col-md-8 col-lg">
				<div class="stat-card stat-wide" matTooltip="Row max(last_sync) and last manual pull time">
					<div class="stat-label">Timestamps</div>
					<div class="stat-sub" *ngIf="(inventoryStatus.total_items || 0) > 0">
						Rows: {{ (inventoryStatus.last_sync_time || inventoryStatus.last_sync) ? ((inventoryStatus.last_sync_time || inventoryStatus.last_sync) | date:'short') : '—' }}
					</div>
					<div class="stat-sub text-muted" *ngIf="(inventoryStatus.total_items || 0) === 0">No cached rows</div>
					<div class="stat-sub" *ngIf="inventoryStatus.last_inventory_pull_at">
						Last pull: {{ inventoryStatus.last_inventory_pull_at | date:'short' }}
					</div>
				</div>
			</div>
		</div>
	</div>

	<p *ngIf="!loading && !inventoryStatus?.success" class="text-muted small">Could not load status. Use refresh.</p>

	<div *ngIf="inventoryListLoading && !loading" class="loading-more-bar">
		<mat-spinner diameter="18"></mat-spinner>
		<span>Loading rows…</span>
	</div>

	<div class="table-wrap" *ngIf="!loading">
		<table class="sku-table inventory-grid-table">
			<thead>
				<tr>
					<th class="sortable" (click)="setSort('stockid')"><span>SKU</span><mat-icon class="sort-icon">{{ sortIcon('stockid') }}</mat-icon></th>
					<th class="sortable" (click)="setSort('warehouse_code')"><span>Warehouse</span><mat-icon class="sort-icon">{{ sortIcon('warehouse_code') }}</mat-icon></th>
					<th>PGS wh</th>
					<th class="sortable" (click)="setSort('internal_qoh')" matTooltip="ERP qty at this loc (bin blank)"><span>Internal QOH</span><mat-icon class="sort-icon">{{ sortIcon('internal_qoh') }}</mat-icon></th>
					<th class="sortable" (click)="setSort('on_demand')" matTooltip="Open sales-order demand at this warehouse"><span>On demand</span><mat-icon class="sort-icon">{{ sortIcon('on_demand') }}</mat-icon></th>
					<th class="sortable" (click)="setSort('quantity_on_hand')"><span>3PL on hand</span><mat-icon class="sort-icon">{{ sortIcon('quantity_on_hand') }}</mat-icon></th>
					<th class="sortable" (click)="setSort('quantity_available')"><span>3PL available</span><mat-icon class="sort-icon">{{ sortIcon('quantity_available') }}</mat-icon></th>
					<th class="sortable" (click)="setSort('sync_status')"><span>Status</span><mat-icon class="sort-icon">{{ sortIcon('sync_status') }}</mat-icon></th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of inventoryItems">
					<tr>
						<td><code>{{ row.stockid }}</code></td>
						<td>{{ row.warehouse_code }}</td>
						<td class="text-muted small">{{ row.pgs_warehouse || '—' }}</td>
						<td [ngClass]="{'text-danger': row.internal_qoh < row.quantity_available, 'text-warning': row.internal_qoh === 0}">{{ row.internal_qoh }}</td>
						<td [ngClass]="{'text-warning': row.on_demand > 0}">{{ row.on_demand }}</td>
						<td>{{ row.quantity_on_hand }}</td>
						<td>{{ row.quantity_available }}</td>
						<td>
							<span class="status-badge" [ngClass]="syncStatusBadgeClass(row.sync_status)">{{ row.sync_status }}</span>
						</td>
					</tr>
					<tr *ngIf="row.lots && row.lots.length > 0" class="lot-detail-row">
						<td colspan="8" class="p-0">
							<div class="lot-details px-3 py-2">
								<table class="sku-table mb-0 small">
									<thead>
										<tr>
											<th>Lot</th>
											<th>Qty</th>
											<th>Expiration</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let lot of row.lots">
											<td>{{ lot.lot_number }}</td>
											<td>{{ lot.quantity }}</td>
											<td>{{ lot.expiration_date ? (lot.expiration_date | date:'shortDate') : '—' }}</td>
											<td>{{ lot.lot_status || 'available' }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="!inventoryListLoading && inventoryItems.length === 0">
					<td colspan="8" class="empty-row">No rows match. Widen filters or load cache via Manual sync (raw) / scheduled job.</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-2" *ngIf="inventoryListTotal > 0">
		<span class="small text-muted">Showing {{ inventoryPageIndex * inventoryPageSize + 1 }}–{{ pageDisplayEnd }} of {{ inventoryListTotal | number }}</span>
		<mat-paginator
			[length]="inventoryListTotal"
			[pageSize]="inventoryPageSize"
			[pageIndex]="inventoryPageIndex"
			[pageSizeOptions]="inventoryPageSizeOptions"
			(page)="onInventoryPage($event)"
			showFirstLastButtons
			class="inventory-items-paginator">
		</mat-paginator>
	</div>

	<!-- ── Inventory Sync Activity ── -->
	<hr class="my-4">
	<div class="d-flex align-items-center mb-2" style="gap:8px">
		<strong class="small">Inventory Sync Activity</strong>
	</div>

	<div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:140px">
			<mat-label>Status</mat-label>
			<mat-select [(ngModel)]="activityFilterStatus" (selectionChange)="loadActivity()">
				<mat-option value="">All</mat-option>
				<mat-option value="success">Success</mat-option>
				<mat-option value="error">Error</mat-option>
				<mat-option value="warning">Warning</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>From</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterFromDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>To</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterToDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:180px">
			<mat-label>SKU</mat-label>
			<input matInput [(ngModel)]="activityFilterPo" (keyup.enter)="loadActivity()" placeholder="Optional">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:110px">
			<mat-label>Limit</mat-label>
			<mat-select [(ngModel)]="activityLimit" (selectionChange)="loadActivity()">
				<mat-option [value]="50">50</mat-option>
				<mat-option [value]="100">100</mat-option>
				<mat-option [value]="250">250</mat-option>
				<mat-option [value]="500">500</mat-option>
			</mat-select>
		</mat-form-field>
		<button mat-stroked-button (click)="loadActivity()" [disabled]="activityLoading">
			<mat-spinner *ngIf="activityLoading" diameter="18"></mat-spinner>
			<mat-icon *ngIf="!activityLoading">refresh</mat-icon>
			Refresh
		</button>
		<button mat-stroked-button (click)="resetActivityFilters()" matTooltip="Reset to last 30 days, errors only">
			<mat-icon>clear</mat-icon>
			Reset
		</button>
		<span class="text-muted small ml-auto" *ngIf="activityTotal > 0">
			Showing {{ activityRows.length }} of {{ activityTotal }} total
		</span>
	</div>

	<div *ngIf="activityError" class="alert alert-warning py-2 small">{{ activityError }}</div>
	<div *ngIf="activityLoading && activityRows.length === 0" class="text-muted small">Loading…</div>
	<div *ngIf="!activityLoading && activityRows.length === 0 && !activityError" class="alert alert-success py-2 small">
		No inventory sync activity matches these filters.
	</div>

	<table *ngIf="activityRows.length > 0" class="table table-sm table-hover">
		<thead>
			<tr>
				<th>When</th>
				<th>Status</th>
				<th>SKU</th>
				<th>Message</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let e of activityRows">
				<td class="text-nowrap text-muted small">{{ e.created_at | date:'M/d/yy, h:mm a' }}</td>
				<td class="text-nowrap">
					<span class="badge" [ngClass]="{
						'badge-success': e.status === 'success',
						'badge-danger': e.status === 'error',
						'badge-warning': e.status === 'warning'
					}">{{ e.status }}</span>
				</td>
				<td class="font-weight-bold small">{{ e.stockid || e.orderno || '—' }}</td>
				<td class="small" [ngClass]="{'text-danger': e.status === 'error'}" style="max-width:38rem;word-break:break-word;">{{ e.message }}</td>
			</tr>
		</tbody>
	</table>
</div>
